var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg5760417OffOnPowerSwitchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64,128a64,64,0,1,1,64-64A64.07,64.07,0,0,1,64,128ZM64,4a60,60,0,1,0,60,60A60.07,60.07,0,0,0,64,4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64,66.5a2,2,0,0,1-2-2V33a2,2,0,0,1,4,0V64.5A2,2,0,0,1,64,66.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64,97A33,33,0,0,1,53.31,32.77a2,2,0,0,1,1.3,3.78,29,29,0,1,0,18.82,0,2,2,0,0,1,1.3-3.79A33,33,0,0,1,64,97Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5760417OffOnPowerSwitchIcon);
export default __webpack_public_path__ + "static/media/5760417_off_on_power_switch_icon.b9fe0089ce3db8ae9f07b7e794446487.svg";
export { ForwardRef as ReactComponent };